import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { updateVendorContact } from '../../../state/vendorSlice';

const WebsiteEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentVendor } = useAppSelector(state => state.vendor);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateVendorContact({ website: event.target.value }));
  };

  return (
    <TextField
      label="Website URL"
      size="small"
      fullWidth
      value={currentVendor?.website || ''}
      onChange={handleChange}
    />
  );
};

export default WebsiteEdit;
